import Endo from '../../entities/Endo/ui/Endo'
import EndoDesc from '../../entities/Endo/ui/EndoDesc'
import EndoPrice from '../../entities/Price/EndoPrice/ui/EndoPrice'
import Footer from '../../widgets/Footer/ui/FooterContact/Footer'
import FooterInfo from '../../widgets/Footer/ui/FooterInfo/FooterInfo'
import HeaderEndo from '../../widgets/HeaderEndo/ui/HeaderEndo'
import styles from './EndodonticsPage.module.scss'

export const EndodonticsPage = () => {
    return(
        <div  className={styles.endo}>
            <HeaderEndo/>
            <Endo/>
            <EndoPrice/>
            <EndoDesc/>
            <Footer/>
            <FooterInfo/>
        </div>
    )
}